import ServerApi from "./../../../libs/api-services/server-api"

class AlphaService extends ServerApi {
  URL_PREFIX = "/v1/secure/user/alphas/"
}

export const alphaService = new AlphaService()
